import "@/App.css";
import Portfolio from "@/pages/Portfolio";

function App() {
  return (
    <div className="App grain">
      <Portfolio />
    </div>
  );
}

export default App;
